import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ModalUsersActionData {
  users: any[];
  title: string;
  description?: string;
  icon: string;
  confirmButtonText: string;
  cancelButtonText?: string;
}

@Component({
  standalone: false,
  selector: 'app-modal-close-sessions',
  templateUrl: './modal-users-action.component.html',
  styleUrls: ['./modal-users-action.component.scss']
})
export class ModalUsersActionComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalUsersActionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalUsersActionData
  ) { }

  ngOnInit() {

  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

}
